// Centralized helper for agent analytics tracking
// Provides: leoAgentId, buildPayload, trackAgentEvent

export function leoAgentId ({ isCustomerFinder, isListenAgent }) {
    if (isCustomerFinder || isListenAgent) return null;

    return process.env.VUE_APP_LEO_AGENT_ID || null;
}

export function guidesAgentId () {
    return process.env.VUE_APP_GUIDES_AGENT_ID || null;
}

export function buildPayload ({
    agentId,
    conversationId,
    messageId,
    content,
    modelUsed = null,
    suggestedPrompt = false,
    toolsUsed = [],
    fileUploaded = false,
}) {
    return {
        agentId,
        conversationId,
        messageId,
        content,
        modelUsed,
        suggestedPrompt,
        toolsUsed,
        fileUploaded,
    };
}

export function trackAgentEvent (eventType, payload) {
    if (typeof window !== 'undefined' && payload?.agentId && typeof window.pendo?.trackAgent === 'function') {
        try {
            window.pendo.trackAgent(eventType, payload);
        } catch {
            // silent fail
        }
    }
}
